import React from 'react';
import { useSelector } from 'react-redux';
import classes from './FinalRejected.module.css';

const FinalRejected = () => {

    const { texts } = useSelector((state) => state.translate);

    return (
        <p className={classes.text} >
            <p className={classes.BigTexts} >{texts.finalRejectedBigText}</p>
            {texts.finalRejectedText}
        </p>
    );
};

export default FinalRejected;
